import "./styles.less";

import { Carousel, Col, Row, Typography } from "antd";
import { useContext, useEffect, useState } from "react";

import { ImagenOptimizada as Img } from "../../../Components/Image/web";
import { useBranInfo } from "./hook";
import { useTheme } from "../../../Styles/ThemeHook";
import { ConfigStateContext } from "../../../../shared-components/Contexts/Configurations/context";
import { firstLetterToUppercase } from "src/utils/Functions";

const { Title, Paragraph } = Typography;

export const BrandInfo = () => {
	const { theme } = useTheme();
	const { data } = useBranInfo();
	const { site_name } = useContext(ConfigStateContext);
	const { translations } = useContext(ConfigStateContext);

	const [settings, setSettings] = useState({
		render: true,
		arrows: false,
		responsive: [],
		speed: 400,
		autoplaySpeed: 6000,
		autoplay: false,
		slidesToShow: 3,
		slidesToScroll: 1,
	});

	useEffect(() => {
		setSettings({
			...settings,
			render: false,
			responsive: [
				{
					breakpoint: Number(
						theme.breakPoints.md.substring(0, theme.breakPoints.md.length - 2)
					),
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						dots: true,
						autoplay: true,
						autoplaySpeed: 6000,
					},
				},
				{
					breakpoint: Number(
						theme.breakPoints.sm.substring(0, theme.breakPoints.sm.length - 2)
					),
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true,
						autoplay: true,
						autoplaySpeed: 6000,
					},
				},
			],
		});
	}, []);

	useEffect(() => {
		if (!settings.render) setSettings({ ...settings, render: true });
	}, [settings.render]);
	if (!settings.render) return null;
	if (!data.length) return null;

	return (<>
		<div className="container brand-info-container">
			<h2 className="ta-center heading heading-2 high">
				{firstLetterToUppercase(translations.mira)} como {site_name} te puede ayudar
			</h2>
			

			<div className="brand-info">
				<Carousel {...settings}>
					{data.map((item, i) => (
						<div key={"brandInfo_item_" + i}>
							<Row justify={"center"}>
								<>
									<Col span={24}>
										<Img
											src={item.imgUrl}
											alt={item.title}
											width={150}
											height={130}
											className={"brand-info-image"}
										/>
									</Col>
									<Col span={24}>
										<h3 className="brand-info-title subhead subhead-semibold high">
											{item.title}
										</h3>
									</Col>
									<Col span={24}>
										<Paragraph className="brand-info-text body body-1 body-regular medium">
											{item.paragraph}
										</Paragraph>
									</Col>
								</>
							</Row>
						</div>
					))}
				</Carousel>
			</div>
		</div>
	</>);
};
